import { SxProps, Theme } from '@mui/material/styles';

/**
 * MUI sets padding-top to 0 on DialogContent that follows a DialogTitle.
 * The dialog theme already uses 24px on the other sides; this puts the top back.
 */
export const screenDialogBodySx: SxProps<Theme> = {
    '&&': { paddingTop: '24px' },
};
